import { useShiftTypeOptionsGet } from '@sbv-clients/data-access-api';

import {
  BaseFieldProps,
  createOptionsFieldBuilder,
} from '../hoc/fields-builder';

const dataFetcher = useShiftTypeOptionsGet;
type ExtraParameters = unknown;
type Props = BaseFieldProps & ExtraParameters;

const hookParamsGetter = (props: Props): ExtraParameters => ({});

export const {
  ShiftTypeSelectField,
  ShiftTypeFormSelectField,
  ShiftTypeDataGridSelectField,
  ShiftTypeIdToLabelRenderer,
} = createOptionsFieldBuilder({
  prefix: 'ShiftType',
  useOptionsHook: dataFetcher,
  extractHookParams: hookParamsGetter,
});
